import React from 'react';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
} from './ui/drawer';
import { MarkHoverCardShell } from './MarkHoverCardShell';
import { SuggestionCard, type Suggestion } from './SuggestionCard';

type SuggestionHoverCardProps = {
  hoveredSuggestion: Suggestion | null;
  hoveredSuggestionPosition: { top: number; left: number } | null;
  suggestionHoverCardContentRef: React.RefObject<HTMLDivElement>;
  isMobile: boolean;
  onClose: () => void;
  onHoverCardMouseEnter: () => void;
  onHoverCardMouseLeave: () => void;
  onApplySuggestion?: (suggestion: Suggestion) => void;
  onRejectSuggestion?: (suggestion: Suggestion) => Promise<void>;
  onDismissSuggestion?: (suggestion: Suggestion) => Promise<void>;
  t: (key: string) => string;
  getIssueTypeLabel: (issueType: string) => string;
};

export const SuggestionHoverCard: React.FC<SuggestionHoverCardProps> = ({
  hoveredSuggestion,
  hoveredSuggestionPosition,
  suggestionHoverCardContentRef,
  isMobile,
  onClose,
  onHoverCardMouseEnter,
  onHoverCardMouseLeave,
  onApplySuggestion,
  onRejectSuggestion,
  onDismissSuggestion,
  t,
  getIssueTypeLabel,
}) => {
  if (!hoveredSuggestion) {
    return null;
  }

  const suggestionCard = (
    <SuggestionCard
      suggestion={hoveredSuggestion}
      isMobileDrawer={isMobile}
      onApplySuggestion={onApplySuggestion}
      onRejectSuggestion={onRejectSuggestion
        ? async (suggestion) => {
            await onRejectSuggestion(suggestion);
            onClose();
          }
        : undefined}
      onDismissSuggestion={onDismissSuggestion
        ? async (suggestion) => {
            await onDismissSuggestion(suggestion);
            onClose();
          }
        : undefined}
      t={t}
      getIssueTypeLabel={getIssueTypeLabel}
    />
  );

  if (isMobile) {
    return (
      <Drawer open={!!hoveredSuggestion} onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}>
        <DrawerContent>
          <DrawerHeader className="p-0">
            {suggestionCard}
          </DrawerHeader>
        </DrawerContent>
      </Drawer>
    );
  }

  if (!hoveredSuggestionPosition) {
    return null;
  }

  return (
    <MarkHoverCardShell
      hoveredPosition={hoveredSuggestionPosition}
      hoverCardContentRef={suggestionHoverCardContentRef}
      onClose={onClose}
      onMouseEnter={onHoverCardMouseEnter}
      onMouseLeave={onHoverCardMouseLeave}
      contentClassName="max-w-2xl w-auto px-4 py-2"
    >
      {suggestionCard}
    </MarkHoverCardShell>
  );
};
